import { api } from 'api/axios';
import { useMutation } from '@tanstack/react-query';

import urls from 'engine/urls';

const putProduct = (data) => { 
  return api.put(urls().PutProduct, data)
};

export const usePutProduct = (options = {}) =>
  useMutation({
    mutationFn: putProduct,
    ...options,
  });
